// The Barracks Bistro — site-wide constants
export const SITE = {
  name: "The Barracks Bistro",
  short: "TBB",
  tagline: "A converted mess hall on the edge of the MRC lake — food, fire, and a proper drinks list.",
  address: "Madras Regimental Centre area, Wellington, The Nilgiris, Tamil Nadu",
  email: "tbb@sigacoffee.com",
  phonePrimary: "+91 82204 10761",
  phoneSecondary: "+91 77607 74919",
  whatsapp: "https://wa.me/918220410761",
  maps: "https://share.google/ZUgGoAKaauXUuDIsA",
  hours: [
    { day: "Mon – Thu", time: "12:00 – 22:30" },
    { day: "Fri – Sat", time: "12:00 – 23:30" },
    { day: "Sunday", time: "11:00 – 22:30" },
  ],
};
